import { Info } from "lucide-react";
import { useState } from "react";

const TextArea = ({ 
    label, 
    name, 
    value, 
    handleChange, 
    error, 
    required = false,
    tooltip,
    rows = 4,
    minLength,
    maxLength,
    helperText
}) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [charCount, setCharCount] = useState(value?.length || 0);

    const handleTextChange = (e) => {
        setCharCount(e.target.value.length);
        handleChange(e);
    };

    return (
        <div className="mb-3">
            <label className="form-label text-muted text-start w-100">
                {label}
                {required && <span className="text-danger ms-1">*</span>}
                {tooltip && (
                    <span 
                        className="ms-2 text-primary cursor-pointer"
                        onMouseEnter={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                    >
                        <Info size={16} />
                    </span>
                )}
            </label>
            {showTooltip && (
                <div className="tooltip-custom bg-light p-2 rounded border mb-2">
                    {tooltip}
                </div>
            )}
            <textarea
                className={`form-control bg-light ${error ? 'is-invalid' : ''}`}
                name={name}
                value={value}
                onChange={handleTextChange}
                rows={rows}
                minLength={minLength}
                maxLength={maxLength}
            />
            <div className="d-flex justify-content-between align-items-center mt-1">
                {helperText && !error && (
                    <small className="text-muted">
                        {helperText}
                    </small>
                )}
                {(minLength || maxLength) && (
                    <small className={`${charCount < minLength ? 'text-danger' : 'text-muted'}`}>
                        {charCount} / {maxLength || minLength} caractères
                    </small>
                )}
            </div>
            {error && (
                <div className="invalid-feedback text-start">
                    {error}
                </div>
            )}
        </div>
    );
};

export default TextArea;